import React, { Component } from 'react';
import { connect } from 'react-redux';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { DEVICES_PAGE_TAB } from 'common/utils/constants';
import {
  updateDevicesPageSelectedDeviceId,
  updateDevicesPageExpandedBundleId,
  updateSelectedDevicesList,
  setMapSelectMode,
  clearSelectedDevicesList,
  updateSelectedDevicesData,
  removeSelectedDevicesData,
  clearSelectedDevicesData
} from 'redux/actions';

export class DeviceCheckBox extends Component {
  render() {
    let targetDeviceID = this.props.targetDeviceID;
    return (
      <div id="DeviceTable_ID_Checkbox_Div" className="DeviceTable_ID_Checkbox_Div">
        <Checkbox
          isChecked={this.props.selectedDevicesDictionary[targetDeviceID]}
          onChange={(event) => {
            // console.log('this.props.', this.props);
            let selected = !(this.props.selectedDevicesDictionary[targetDeviceID] === true);
            this.props.dispatch(updateSelectedDevicesList(this.props.activeTab, { [targetDeviceID]: selected }));
            selected
              ? this.props.dispatch(
                  updateSelectedDevicesData(this.props.activeTab, { [targetDeviceID]: this.props.deviceTwin })
                )
              : this.props.dispatch(removeSelectedDevicesData(this.props.activeTab, targetDeviceID));

            if (this.props.mapSelectMode.bulk === false || this.props.mapSelectMode.allSelect === true) {
              this.props.dispatch(setMapSelectMode({ bulk: true, allSelect: false }, this.props.activeTab));
            }
            event.stopPropagation(); //stop default row click stuff from happening
          }}
        />
      </div>
    );
  }
}

DeviceCheckBox = connect((store) => {
  const activeTab = store.ui.devicesPage.activeTab;
  let selectedDevicesDictionary;
  let mapSelectMode;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    selectedDevicesDictionary = store.ui.devicesPage.pivotTab.selectedDevicesDictionary;
    mapSelectMode = store.ui.devicesPage.pivotTab.selectMode;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    selectedDevicesDictionary = store.ui.devicesPage.echoTab.selectedDevicesDictionary;
    mapSelectMode = store.ui.devicesPage.echoTab.selectMode;
  } else {
    selectedDevicesDictionary = store.ui.devicesPage.allDevicesTab.selectedDevicesDictionary;
    mapSelectMode = store.ui.devicesPage.allDevicesTab.selectMode;
  }
  return {
    activeTab,
    selectedDevicesDictionary,
    mapSelectMode
    // mapSelectMode: store.ui.devicesPage.selectMode
  };
})(DeviceCheckBox);

/* Same gig as DeviceCheckBox, moving props into this component prevents rerendering, this time I did it so headers don't flicker */
export class DeviceHeaderCheckBox extends Component {
  render() {
    return (
      <div id="DeviceTable_ID_Checkbox_Div" className="DeviceTable_ID_Checkbox_Div">
        <Checkbox
          isChecked={this.props.mapSelectMode.allSelect === true}
          onChange={(event) => {
            if (this.props.mapSelectMode.allSelect !== true) {
              let selectedDeviceIDs = {};
              let selectedDevicesData = {};
              this.props.deviceTableSet.devices.forEach((device) => {
                if (device.bundleId) {
                  selectedDeviceIDs[device.bundleId] = true;
                  selectedDevicesData[device.bundleId] = device;
                } else {
                  selectedDeviceIDs[device.id] = true;
                  selectedDevicesData[device.id] = device;
                }
              });
              // console.log('this.props.', this.props);
              this.props.dispatch(updateSelectedDevicesList(this.props.activeTab, selectedDeviceIDs));
              this.props.dispatch(updateSelectedDevicesData(this.props.activeTab, selectedDevicesData));
              this.props.dispatch(setMapSelectMode({ bulk: true, allSelect: true }, this.props.activeTab));
            } else {
              this.props.dispatch(updateDevicesPageSelectedDeviceId(''));
              this.props.dispatch(updateDevicesPageExpandedBundleId(''));
              this.props.dispatch(clearSelectedDevicesList(this.props.activeTab));
              this.props.dispatch(clearSelectedDevicesData(this.props.activeTab));
              this.props.dispatch(setMapSelectMode({ allSelect: false }, this.props.activeTab));
            }
          }}
        />
      </div>
    );
  }
}

DeviceHeaderCheckBox = connect((store) => {
  const activeTab = store.ui.devicesPage.activeTab;
  let selectedDevicesDictionary;
  let mapSelectMode;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    selectedDevicesDictionary = store.ui.devicesPage.pivotTab.selectedDevicesDictionary;
    mapSelectMode = store.ui.devicesPage.pivotTab.selectMode;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    selectedDevicesDictionary = store.ui.devicesPage.echoTab.selectedDevicesDictionary;
    mapSelectMode = store.ui.devicesPage.echoTab.selectMode;
  } else {
    selectedDevicesDictionary = store.ui.devicesPage.allDevicesTab.selectedDevicesDictionary;
    mapSelectMode = store.ui.devicesPage.allDevicesTab.selectMode;
  }

  return {
    activeTab,
    selectedDevicesDictionary,
    mapSelectMode,
    // mapSelectMode: store.ui.devicesPage.selectMode
  };
})(DeviceHeaderCheckBox);
